import {
	READ_EXCHANGE,
	CREATE_EXCHANGE,
	UPDATE_EXCHANGE,
	DELETE_EXCHANGE
} from '../config/actionTypes';

const initialState = [];

const ExchangeReducer = (state = initialState, action) => {
	switch (action.type) {
		case READ_EXCHANGE:
			return action.data;
		case CREATE_EXCHANGE:
			return state;
		case UPDATE_EXCHANGE:
			const newData = state.concat(action.data);
			return newData;
		case DELETE_EXCHANGE:
			return state;
		default:
			return state;
	}
};

export default ExchangeReducer;
